import trustLibrary from '../../../src/data/trustRoleLibrary.generated.json' with { type: 'json' };

function legacyProfile(trust) {
  return {
    roles: Object.fromEntries((trust.role_overrides || []).filter((role) => role.role_id).map((role) => [
      role.role_id,
      {
        included: role.active !== false,
        uniform: { garmentId: 'tunic', colourId: role.uniform_id || 'no_uniform', note: role.notes || '' },
        careSettings: role.setting_id ? [role.setting_id] : [],
        journeyIds: [], contentComment: '',
        legacyMetadata: {
          trustRoleId: role.trust_role_id || null, displayName: role.display_name || null,
          description: role.description || null, band: role.band || null, uniformRuleId: role.uniform_rule_id || null,
        },
      },
    ])),
    uniforms: trust.uniforms || [],
  };
}

export const allTrusts = (trustLibrary.trusts || []).map((trust) => ({
  id: trust.trust_id || trust.id, name: trust.name, shortName: trust.short_name || trust.name,
  active: trust.active !== false, lifecycleStatus: trust.active === false ? 'deactivated' : 'existing',
  source: 'generated', legacyProfile: legacyProfile(trust),
}));
export const trusts = allTrusts.filter((trust) => trust.active !== false);

// These labels describe the whole garment combination, not one colour swatch.
// Keep the original IDs and HEX values. The custom editor has its own palette.
const fixedIllustrationColourIds = new Set(['paramedic_green']);
const legacyColourOptions = [{id:'no_uniform',name:'No standard uniform',body:'#6B7280',trim:'#374151'}, ...(trustLibrary.colours || []).filter(c=>c.colour_id).map(c=>({
  id:c.colour_id,
  name:c.colour_id === 'grey' ? 'Grey with navy trim' : c.colour_id === 'grey_solid' ? 'Grey' : c.description || c.default_name || c.colour_id.replaceAll('_',' '),
  body:c.body_hex || '#CBD5E1',trim:c.trim_hex || c.body_hex || '#64748B',
}))].filter((v,i,a)=>a.findIndex(x=>x.id===v.id)===i);

export const colours = legacyColourOptions
  .filter(item => !fixedIllustrationColourIds.has(item.id))
  .sort((a,b)=>a.name.localeCompare(b.name,'en',{sensitivity:'base'}) || a.id.localeCompare(b.id));
export const garments = [
  {id:'scrubs',name:'Scrubs'},
  {id:'healthcare_tunic',name:'Healthcare tunic'},
  {id:'no_uniform',name:'No uniform / professional dress'},
];
export const careSettingOptions = ['hospital_wards','outpatients_clinics','emergency_department','operating_theatres','day_surgery','critical_care','maternity','community','primary_care','home_visits','rehabilitation','diagnostics_imaging','laboratories','mental_health_services','paediatrics','research'];
export const journeyOptions = [
{id:'day-surgery',title:'Day Surgery'},{id:'maternity',title:'Maternity'},{id:'emergency-department',title:'Emergency Department'},{id:'medical-inpatient',title:'Medical Inpatient'},{id:'surgical-inpatient',title:'Surgical Inpatient'},{id:'outpatients',title:'Outpatients'},{id:'imaging-diagnostics',title:'Imaging & Diagnostics'},{id:'critical-care',title:'Critical Care'},{id:'paediatrics',title:"Children's Services"},{id:'cancer-care',title:'Cancer Care'}
];
